import type { JSX } from 'react';

interface ConditionalWrapperProps {
  children: JSX.Element;
  condition: boolean;
  wrapper: (children: JSX.Element) => JSX.Element;
}

/** Renders `children` as-is, or wrapped when `condition` is true. */
export const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps) => {
  return condition ? wrapper(children) : children;
};
